import React from 'react'
import { Typography } from '@material-ui/core'
import { Trans } from 'react-i18next'
import AccountForm, { AccountFormState } from 'components/forms/account/accountForm'
import SubmitButton from 'components/common/submitButton'
import clsx from 'clsx'
import AuthenticateContent from 'components/layouts/components/authenticateContent'
import AuthenticateActions from 'components/layouts/components/authenticateActions'
import { useStyles } from './accountEditView.css'

interface Props {
    onSubmit: (values: AccountFormState) => void
    inProgress: boolean
    initialValues: AccountFormState
    onPrevious: () => void
}

const AccountEditView: React.FC<Props> = ({ onPrevious, ...formData }) => {
    const classes = useStyles()

    return (
        <AccountForm {...formData}>
            {(content, actions) => (
                <>
                    <AuthenticateContent>
                        <Typography variant="h1" className={classes.title}>
                            <Trans i18nKey="views.account.title" />
                        </Typography>
                        {content}
                    </AuthenticateContent>
                    <AuthenticateActions>
                        <SubmitButton variant="contained" onClick={onPrevious}>
                            <Trans i18nKey="actions.previous" />
                        </SubmitButton>
                        {actions.map((action, index) => (
                            <SubmitButton
                                key={index}
                                variant="contained"
                                color="primary"
                                {...action}
                                className={clsx(action.className)}
                            />
                        ))}
                    </AuthenticateActions>
                </>
            )}
        </AccountForm>
    )
}

export default AccountEditView
